import PropTypes from 'prop-types';

export const QuoteListItemPropTypes = {
  quote: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        duration_seconds: PropTypes.number,
        session_count: PropTypes.number,
        session_length_seconds: PropTypes.number,
        list_price_cents: PropTypes.number,
        quoted_price_cents: PropTypes.number,
      })
    ),
    ends_at: PropTypes.string,
    number_of_payments: PropTypes.number,
  }),
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    packages: PropTypes.shape({}),
    content: PropTypes.shape({
      images: PropTypes.shape({
        hero: PropTypes.shape({
          path: PropTypes.string,
          options: PropTypes.arrayOf(PropTypes.string),
          responsive_paths: PropTypes.shape({
            '1x': PropTypes.string,
            '2x': PropTypes.string,
          }),
          properties: PropTypes.string,
        }),
        product: PropTypes.shape({
          path: PropTypes.string,
          options: PropTypes.arrayOf(PropTypes.string),
          responsive_paths: PropTypes.shape({
            '1x': PropTypes.string,
            '2x': PropTypes.string,
          }),
          properties: PropTypes.string,
        }),
      }),
    }),
    meta: PropTypes.shape({
      links: PropTypes.shape({
        details_page: PropTypes.string,
        buy_now: PropTypes.string,
        preview: PropTypes.string,
        catalog: PropTypes.string,
      }),
      list_price: PropTypes.shape({
        amount: PropTypes.number,
        currency_code: PropTypes.string,
        formatted: PropTypes.string,
      }),
      schedule_summary: PropTypes.shape({
        week_count: PropTypes.number,
        sessions_per_week: PropTypes.number,
        session_duration_seconds: PropTypes.number,
        next_class_date: PropTypes.string,
        next_start_date: PropTypes.string,
      }),
    }),
  }),
};
